import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { EncryptionDecryptionService } from '../encryption-decryption/encryption-decryption.service';
import { UntypedFormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Observable, TimeoutError, catchError, timeout } from 'rxjs';
import { Router } from '@angular/router';
import { SocialAuthService } from '@abacritt/angularx-social-login';
import { environment } from 'src/environments/environment';
import { E } from '@angular/cdk/keycodes';
import { MatDialog } from '@angular/material/dialog';
import { saveAs } from 'file-saver';
import { BehaviorSubject } from 'rxjs';
import * as FileSaver from 'file-saver';
import { AuthService } from 'src/app/core/service/auth.service';
import { CustomTostComponent } from 'src/app/custom-tost/custom-tost.component';
import { GlobalService } from '../global/global.service';
import { CookieService } from 'ngx-cookie-service';
// var FileSaver = require('file-saver');

@Injectable({
  providedIn: 'root'
})
export class AppService {
  public staticToken: string = '';
  public imageUrl = GlobalService.imageURL
  private isAdminLoginSubject = new BehaviorSubject<boolean>(false);
  isAdminSubject$ = this.isAdminLoginSubject.asObservable();
  constructor(private snackBar: MatSnackBar, private ed: EncryptionDecryptionService, private dialog: MatDialog, private cookieService: CookieService,
    private http: HttpClient, private router: Router, private socialAuthService: SocialAuthService, private templateAuth: AuthService) {
  }
  getIsAdminValue(): boolean {
    return this.isAdminLoginSubject.getValue();
  }

  setIsAdminValue(value: boolean): void {
    this.isAdminLoginSubject.next(value);
  }
  // get and set data in local storage in encrypted / decrypted form
  storeData(key: string, value: any) {
    localStorage.setItem(key, value);
  }
  getData(value: any) {
    const data = localStorage.getItem(value);
    return data !== null ? data : '';
  }
  storeSessionData(key: string, value: any) {

    sessionStorage.setItem(key, value);
  }
  getSessionData(value: any) {
    const data = sessionStorage.getItem(value);
    return data !== null ? data : '';
  }
  removeSessionData(value: any) {
    sessionStorage.removeItem(value);
  }
  //to remvoe the data stored in local Storage
  removeData(value: any) {
    localStorage.removeItem(value);
  }
  //get encrypted text in string 
  getEncryptedText(value: any) {
    if (environment.production == true) {
      return this.ed.encryptUsingCrypto(value);
    }
    else {
      return value
    }
  }
  //get decrypted text in string 
  getDecryptedText(value: any) {
    if (environment.production == true) {
      return this.ed.decryptUsingCrypto(value);
    }
    else {
      return value
    }
  }
  // show error and success toast messages
  showToastMessage(type: string, text: string, duration = 3000) {

    let image = '';
    let title = ''
    switch (type) {
      case "success":
        title = 'Success!'
        image = 'assets/images/icons/success_ic.svg';
        this.openToast('snackbar-success', title, text, image, 'top', 'right', duration = 3000)
        break;
      case "warning":
        title = 'Warning!'
        image = 'assets/images/icons/warning_ic.svg';
        this.openToast('snackbar-warning', title, text, image, 'top', 'right', duration = 3000)
        break;
      case "info":
        title = 'Info!'
        image = 'assets/images/icons/info_ic.svg';
        this.openToast('snackbar-info', title, text, image, 'top', 'right', duration = 3000)
        break;
      case "error":
        title = 'Error!'
        image = 'assets/images/icons/error_ic.svg';
        this.openToast('snackbar-danger', title, text, image, 'top', 'right', duration = 3000)
        break;
      default:
        break;
    }
  }
  openToast(colorName: string, title: string, text: string, image: string,
    placementFrom: MatSnackBarVerticalPosition, placementAlign: MatSnackBarHorizontalPosition, duration) {
    // at some places there can be custom duration hence passing this value
    const ref = this.snackBar.openFromComponent(CustomTostComponent, {
      duration: duration,
      verticalPosition: placementFrom,
      horizontalPosition: placementAlign,
      panelClass: colorName,
      data: {
        text: text,
        image: image,
        title: title
      },
    });
    ref.instance.title = title;
    ref.instance.text = text;
    ref.instance.image = image;
  }
  isControlHasError(formName: UntypedFormGroup, controlName: string, validationType: string,): boolean {
    const control = formName.controls[controlName];
    if (!control) {
      return false;
    }
    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }
  postWithTimeout(url: string, data: any): Observable<any> {
    return this.http.post(url, data)
      .pipe(
        timeout(5000),
        catchError(error => {
          if (error instanceof TimeoutError) {
            console.error('Request timed out');
          }
          throw error;
        })
      );

  }
  startPageLogic(page, itemPerPage) {
    if (page > 1) {
      return (page - 1) * itemPerPage;
    }
    else {
      return 0
    }
  }
  downloadFile(data, name) {
    let fileName = new Date().getTime() + name;
    if (data.includes('https') && data.includes('amazonaws')) {
      window.open(data, "_self")
    }
    else if (data.includes('https')) {
      FileSaver.saveAs(data, fileName)
    }
    else {
      FileSaver.saveAs(this.imageUrl + data, fileName)
    }
  }
  getUrl(url: string) {
    if (url.includes('https')) {
      return url
    }
    else {
      let new_url: string = GlobalService.imageURL + url;
      return new_url
    }
  }
  apiWithTimeout(httpReq, milliseconds) {
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        reject(new Error("Data fetch failed in " + milliseconds + " ms"))
      }, milliseconds)
      httpReq.then(res => { resolve(res) }, err => { reject(err) })
    })
  };
  logOut() {
    //close all the opened dialog box
    this.dialog.closeAll()
    this.removeData('training-portal.authToken')
    this.removeData('training-portal.userInfo')
    this.cookieService.delete('training-portal.authToken')
    if (this.getData('socialLogin')) {
      if (this.getData('socialLogin') == 'false') {
        this.router.navigate(['/authentication/signin']);
        this.removeData('socialLogin')
      }
      else {
        this.socialAuthService.signOut().then(() => {
          this.router.navigate(['/authentication/signin']);
          this.removeData('socialLogin')
        })
      }

    }
    else {
      this.router.navigate(['/authentication/signin']);
    }
    if (this.getData('rememberMe')) {
      this.removeData('rememberMe')
    }

  }
  getPermissionforUser() {
    const perm = ["COMPANY", "user_management", "courses", "document", 'package', 'store', 'important_notice'];
    return perm
  }
  getFileNameFromUrl(url) {
    const match = url.match(/\/api\/([^\/]+)$/);

    if (match) {
      const filename = match[1];
      return filename
    } else {
      return url;
    }
  }
}